export const marketingMotion = {
  duration: {
    fast: 0.2,
    base: 0.4,
    slow: 0.65,
  },
  easing: {
    standard: [0.22, 1, 0.36, 1] as const,
    smooth: [0.16, 1, 0.3, 1] as const,
  },
  spring: {
    gentle: { type: "spring", stiffness: 130, damping: 20 } as const,
  },
  viewport: {
    once: true,
    amount: 0.25,
  },
} as const;
